(function () {
  var cfg = window.SCX || {};
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(cents) {
    var f = cfg.money || '£{{amount}}';
    return f
      .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, (cents / 100).toFixed(2).replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/<[^>]+>/g, '');
  }

  /* ---- wishlist store ---- */
  var LS = 'sc_wishlist';
  function wget() { try { return JSON.parse(localStorage.getItem(LS) || '[]'); } catch (e) { return []; } }
  function wset(a) { localStorage.setItem(LS, JSON.stringify(a)); wcount(); }
  function wcount() { var el = $('#sc-wish-count'); if (el) el.textContent = wget().length; }

  /* ---- cart ---- */
  function getCart() { return fetch('/cart.js').then(function (r) { return r.json(); }); }
  function addToCart(id, q) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: q || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return renderDrawer().then(openDrawer);
    }).catch(function () { alert('Could not add to cart.'); });
  }
  function changeLine(line, q) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: q })
    }).then(renderDrawer);
  }
  function renderDrawer() {
    return getCart().then(function (c) {
      var hc = $('#sc-cart-count'); if (hc) hc.textContent = c.item_count;
      var wrap = $('#sc-items'); if (!wrap) return;
      wrap.innerHTML = c.items.length ? c.items.map(function (it, i) {
        var img = it.image ? it.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_300x$1$2') : '';
        return '<div class="scd-item"><img src="' + img + '" alt="">' +
          '<div><p class="scd-t">' + it.product_title + '</p>' +
          '<p class="scd-p">' + money(it.final_line_price) + '</p>' +
          '<p class="scd-v">' + (it.variant_title || '') + '</p>' +
          '<div class="scd-qty"><button data-sc-line="' + (i + 1) + '" data-sc-q="' + (it.quantity - 1) + '">−</button><span>' + it.quantity + '</span><button data-sc-line="' + (i + 1) + '" data-sc-q="' + (it.quantity + 1) + '">+</button></div>' +
          '<button class="scd-rm" data-sc-line="' + (i + 1) + '" data-sc-q="0">Remove</button></div></div>';
      }).join('') : '<p class="scd-empty">Your cart is empty.</p><a href="/collections/all" style="display:inline-block;margin-top:14px;background:#0a0a0a;color:#fff;font-size:11px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;text-decoration:none;padding:14px 26px;">Shop the collection</a>';
      var ship = $('#sc-ship'), t = cfg.ship || 0;
      if (ship) {
        if (t > 0) {
          ship.hidden = false;
          var left = t - c.total_price;
          ship.textContent = left > 0 ? 'Spend ' + money(left) + ' more to unlock free shipping' : 'Free shipping unlocked ✓';
        } else ship.hidden = true;
      }
      var sub = $('#sc-dsub'); if (sub) sub.textContent = money(c.total_price);
      var dc = $('#sc-dcount'); if (dc) dc.textContent = c.item_count + (c.item_count === 1 ? ' item' : ' items');
    });
  }
  function openDrawer() { $('#sc-drawer').classList.add('on'); $('#sc-overlay').classList.add('on'); document.body.classList.add('sc-locked'); }
  function closeDrawer() {
    var d = $('#sc-drawer'); if (d) d.classList.remove('on');
    closeModal();
    var o = $('#sc-overlay'); if (o) o.classList.remove('on');
    document.body.classList.remove('sc-locked');
  }

  /* ---- wishlist modal ---- */
  var mp = null, msel = null;
  function openModal(p) {
    mp = p; msel = null;
    $('#scw-title').textContent = p.title;
    $('#scw-price').textContent = money(p.price);
    $('#scw-imgs').innerHTML = (p.imgs || []).slice(0, 3).map(function (s) { return '<img src="' + s + '" alt="">'; }).join('');
    $('#scw-sizes').innerHTML = p.variants.map(function (v) {
      return '<button data-scw-vid="' + v.id + '" data-scw-size="' + v.t + '"' + (v.a ? '' : ' disabled') + '>' + v.t + '</button>';
    }).join('');
    $('#sc-wmodal').hidden = false;
    $('#sc-overlay').classList.add('on');
  }
  function closeModal() {
    var m = $('#sc-wmodal'); if (m) m.hidden = true;
    var d = $('#sc-drawer');
    if (!(d && d.classList.contains('on'))) { var o = $('#sc-overlay'); if (o) o.classList.remove('on'); }
  }

  /* ---- wishlist page ---- */
  function renderWishlist() {
    var g = $('#sc-wishlist-grid'); if (!g) return;
    var a = wget();
    g.innerHTML = a.length ? a.map(function (it, i) {
      return '<div style="background:#efeae2;position:relative;">' +
        '<a href="' + (it.url || '#') + '" style="display:block;"><div style="aspect-ratio:3/4;overflow:hidden;"><img src="' + (it.img || '') + '" alt="" style="width:100%;height:100%;object-fit:cover;"></div></a>' +
        '<div style="padding:14px;">' +
        '<p style="font-size:13px;font-weight:600;margin:0;">' + it.title + '</p>' +
        '<p style="font-size:13px;color:#555;margin:4px 0 12px;">' + (it.size ? 'Size ' + it.size + ' · ' : '') + money(it.price) + '</p>' +
        '<div style="display:flex;gap:12px;align-items:center;">' +
        '<button data-sc-add="' + it.vid + '" style="background:#0a0a0a;color:#fff;border:none;font-family:\'Archivo\';font-size:11px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;padding:12px 18px;cursor:pointer;">Add to cart</button>' +
        '<button data-sc-wrm="' + i + '" style="background:none;border:none;font-family:\'Archivo\';font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#999;text-decoration:underline;cursor:pointer;">Remove</button>' +
        '</div></div></div>';
    }).join('') : '<p style="grid-column:1/-1;color:#888;font-size:14px;">No favourites yet. Tap the ♡ on any product to save it here.</p>';
  }

  /* ---- events ---- */
  document.addEventListener('click', function (e) {
    if (e.target.id === 'sc-overlay') { closeDrawer(); return; }
    var t = e.target.closest('button, a');
    if (!t) return;
    if (t.hasAttribute('data-sc-add')) { e.preventDefault(); addToCart(t.getAttribute('data-sc-add')); return; }
    if (t.hasAttribute('data-sc-cart-toggle')) { e.preventDefault(); renderDrawer().then(openDrawer); return; }
    if (t.hasAttribute('data-sc-close')) { closeDrawer(); return; }
    if (t.hasAttribute('data-sc-close-modal')) { closeModal(); return; }
    if (t.hasAttribute('data-sc-line')) { changeLine(parseInt(t.getAttribute('data-sc-line'), 10), parseInt(t.getAttribute('data-sc-q'), 10)); return; }
    if (t.classList.contains('sc-heart') || t.hasAttribute('data-sc-wish')) {
      e.preventDefault(); e.stopPropagation();
      var host = t.closest('[data-sc-product]');
      if (host) openModal(JSON.parse(host.getAttribute('data-sc-product')));
      return;
    }
    if (t.hasAttribute('data-scw-vid')) {
      $$('#scw-sizes button').forEach(function (b) { b.classList.remove('on'); });
      t.classList.add('on');
      msel = { vid: t.getAttribute('data-scw-vid'), size: t.getAttribute('data-scw-size') };
      return;
    }
    if (t.id === 'scw-add') {
      if (!mp) return;
      var a = wget();
      a.push({
        title: mp.title, img: (mp.imgs || [])[0], price: mp.price, url: mp.url,
        size: msel ? msel.size : '', vid: msel ? msel.vid : (mp.variants[0] && mp.variants[0].id)
      });
      wset(a); closeModal(); renderWishlist();
      return;
    }
    if (t.hasAttribute('data-sc-wrm')) {
      var arr = wget(); arr.splice(parseInt(t.getAttribute('data-sc-wrm'), 10), 1);
      wset(arr); renderWishlist(); return;
    }
  });

  /* AJAX add-to-cart on product page -> open drawer instead of redirect */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.id !== 'sc-product-form') return;
    e.preventDefault();
    var id = (f.querySelector('#sc-variant-id') || {}).value;
    if (!id) return;
    var qEl = f.querySelector('[name=quantity]');
    addToCart(id, qEl ? parseInt(qEl.value, 10) || 1 : 1);
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  renderWishlist(); wcount(); renderDrawer();

  /* ---------- Mobile menu ---------- */
  function menuToggle(open) {
    var m = document.getElementById('sc-mmenu'), ov = document.getElementById('sc-mmenu-ov'), b = document.querySelector('.sc-burger');
    if (!m) return;
    var on = (typeof open === 'boolean') ? open : !m.classList.contains('on');
    m.classList.toggle('on', on); if (ov) ov.classList.toggle('on', on);
    if (b) { b.classList.toggle('on', on); b.setAttribute('aria-expanded', on); }
    document.body.classList.toggle('sc-locked', on);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sc-menu], [data-sc-menu-close], #sc-mmenu a');
    if (!t) return;
    if (t.hasAttribute('data-sc-menu')) { menuToggle(); }
    else { menuToggle(false); }
  });

  /* ---------- Newsletter popup ---------- */
  (function () {
    var pop = document.getElementById('sc-popup');
    if (!pop) return;
    var KEY = 'sc_popup_until';
    var days = parseInt(pop.getAttribute('data-days'), 10) || 14;
    var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 6) * 1000;
    function snooze(d) { try { localStorage.setItem(KEY, Date.now() + d * 86400000); } catch (e) {} }
    function show() {
      pop.classList.add('on');
      var ov = document.getElementById('sc-popup-overlay'); if (ov) ov.classList.add('on');
    }
    function hide() {
      pop.classList.remove('on');
      var ov = document.getElementById('sc-popup-overlay'); if (ov) ov.classList.remove('on');
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sc-popup-close]') || e.target.id === 'sc-popup-overlay') { hide(); snooze(days); }
      if (e.target.closest('[data-sc-popup-submit]')) { snooze(365); }
    });
    var until = 0; try { until = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) {}
    if (Date.now() < until) return;
    setTimeout(show, delay);
  })();


  /* ---------- Klaviyo direct subscribe (popup + newsletter) ---------- */
  function kSubscribe(email) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + (cfg.kCompany || ''), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Website signup',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: (cfg.kList || '') } } }
        }
      })
    }).then(function (r) {
      if (r.status === 202 || r.ok) return true;
      return r.json().then(function (j) { throw new Error(JSON.stringify(j)); });
    });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.hasAttribute || !f.hasAttribute('data-sc-klaviyo')) return;
    e.preventDefault();
    var input = f.querySelector('input[type=email]');
    var email = input && input.value.trim();
    var ok = f.querySelector('[data-k-success]') || (f.parentElement && f.parentElement.querySelector('[data-k-success]'));
    var err = f.querySelector('[data-k-error]') || (f.parentElement && f.parentElement.querySelector('[data-k-error]'));
    if (!email || email.indexOf('@') < 1) { if (err) { err.textContent = 'Please enter a valid email address.'; err.hidden = false; } return; }
    var btn = f.querySelector('button[type=submit]');
    if (btn) btn.disabled = true;
    if (err) err.hidden = true;
    kSubscribe(email).then(function () {
      if (ok) ok.hidden = false;
      f.style.display = 'none';
      try { localStorage.setItem('sc_popup_until', Date.now() + 365 * 86400000); } catch (e2) {}
    }).catch(function () {
      /* Klaviyo endpoint unreachable (ad-blocker etc.) -> fall back to Shopify first-party form */
      try { localStorage.setItem('sc_popup_until', Date.now() + 365 * 86400000); } catch (e2) {}
      var sf = document.createElement('form');
      sf.method = 'POST'; sf.action = '/contact#newsletter'; sf.style.display = 'none';
      function add(n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; sf.appendChild(i); }
      add('form_type', 'customer'); add('utf8', '\u2713');
      add('contact[email]', email); add('contact[tags]', 'newsletter,popup');
      document.body.appendChild(sf);
      sf.submit();
    });
  });

})();